import angular from 'angular';
import { SharprEventTrackerService } from './SharprEventTrackerService';
import '../api/apiModule.js';
import '../identity/identityModule.js';

angular
	.module('sh.sharprEventTracker', ['sh.api', 'sh.identity'])
	.service('SharprEventTracker', SharprEventTrackerService); // Constructor receives injections
